import React, { useState } from "react";
import { username } from "../../Functionalities/Config";
import { showMessage } from "../../Functionalities/Functions";
import { rupees } from "../Insights/format";
import { PAYMENT_MODES, blankPayment, recordPayment, todayInIndia } from "./riderPaymentsData";

const Field = ({ label, children }) => (
  <label className="rider-form__field">
    <span className="stl-field__label">{label}</span>
    {children}
  </label>
);

export default function PaymentForm({ riderId, onSaved, onCancel }) {
  const [values, setValues] = useState(blankPayment);
  const [saving, setSaving] = useState(false);
  const change = (key) => (e) => setValues((prev) => ({ ...prev, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const body = await recordPayment(riderId, values);
    setSaving(false);
    if (body.Status !== true) {
      showMessage(body.Error || "The payment was not saved", "danger", "Not saved", "top", "top-right");
      return;
    }
    showMessage(`${rupees(body.payment.amount)} recorded`, "success", "Saved", "top", "top-right");
    onSaved();
  };

  return (
    <form className="rider-form" onSubmit={submit}>
      <Field label="Amount (₹)">
        <input className="stl-input" type="number" min="1" step="0.01" required value={values.amount} onChange={change("amount")} />
      </Field>
      <Field label="Paid on">
        <input className="stl-input" type="date" required max={todayInIndia()} value={values.paid_on} onChange={change("paid_on")} />
      </Field>
      <Field label="Mode">
        <select className="stl-input" value={values.mode} onChange={change("mode")}>
          {PAYMENT_MODES.map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
      </Field>
      <Field label="To account">
        <input className="stl-input" placeholder="e.g. Foodoor HDFC" value={values.account} onChange={change("account")} />
      </Field>
      <Field label="Reference">
        <input className="stl-input" placeholder="UPI or bank reference" value={values.reference} onChange={change("reference")} />
      </Field>
      <Field label="Collected by">
        <input className="stl-input" placeholder={username || "You"} value={values.collected_by} onChange={change("collected_by")} />
      </Field>
      <Field label="Note">
        <input className="stl-input" value={values.notes} onChange={change("notes")} />
      </Field>
      <div className="rider-form__actions">
        <button type="button" className="stl-btn stl-btn--secondary" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="stl-btn stl-btn--primary" disabled={saving || !riderId}>
          {saving ? "Saving…" : "Save payment"}
        </button>
      </div>
    </form>
  );
}
